/**
 * 验证全角半角
 */
export const validateCharCodeAt = (value) => {
  if (value.length > 0) {
    for (var i = value.length - 1; i >= 0; i--) {
      unicode = value.charCodeAt(i);
      if (unicode > 65280 && unicode < 65375) {
        return false;
      }
    }
  }
  return true;
};

/**
 * 验证姓名或名称
 */
export const validName = (rule, value, callback) => {
  if (value !== undefined && value.length >= 20) {
    return false;
  } else if (value && !validSpecial(value)) {
    return false;
  } else if (value && value.toLowerCase() === 'null') {
    return false;
  }
  return true;
};

/**
 * 验证小数点只能2位
 */
export const validateFloat = (value, num) => {
  let ArrMen = value.split("."); //截取字符串
  if (ArrMen.length === 2) {
    if (ArrMen[1].length > parseInt(num)) { //判断小数点后面的字符串长度
      return false
    }
    return true
  }
  return true
};

/**
 * 验证只能是整数，且不能为0
 */
export const validInt = (value) => {
  value = parseFloat(value);
  if (value && typeof value !== 'number' || value % 1 !== 0) {
    return false;
  }
  return true;
};

/**
 * 验证范围
 */
export const validateRange = (value, start, end) => {
  if (value && parseInt(value) < start || parseInt(value) > end) {
    return false
  }
  return true;
};


/*--------------------------------------------------------------------------------*/

/**
 * 验证禁用中文
 */
export const validateChinese = (rule, value, callback) => {
  let regExp = /[\u4e00-\u9fa5]/g;
  if (value && regExp.test(value)) {
    callback(new Error(`门店标识不能含有中文`));
  }
  callback();
};


/**
 * 验证输入框，不能输入特殊字符
 */
export const validSpecial = (value) => {
  let regExp = /[`~!@#$%^&*()/\\|,.<>?"'();:_+=\[\]{}]/;
  if (value && regExp.test(value)) {
    return false;
  }
  return true;
};
export const validSpecial1 = (value) => {
  let regExp = /[`~!@#$%^&*/\\|,.<>?"';:_+=\[\]{}]/;
  if (value && regExp.test(value)) {
    return false;
  }
  return true;
};

export const validateSpecial = (rule, value, callback) => {
  let regExp = /[`~!@#$%^&*()/\\|,.<>?"'();:_+=\[\]{}]/;
  //let regExp = /[`*/\\|,.<>?"':]/;
  if (value && regExp.test(value)) {
    //callback(new Error(`不能包含下列任何特殊字符（\\ /:*?' " \`<>|）！%`));
    callback(new Error(`不能包含下列任何特殊字符 ~!@#$%^&*()/\\|,.<>?"'();:_+=\[\]{}`));
  } else if (value && value.toLowerCase() == "null") {
    callback(new Error(`名称请不要输入'null'`))
  }
  callback();
};

/**
 * 价格
 */
export const valiPrice = (rule, value, callback) => {
  let reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[0-9][1-9]*\.\d{1,2})))$/;
  if (!reg.test(value)) {
    callback(new Error('请输入正确的价格'));
  }else{
    callback()
  }
};
/**
 * 验证只有字母和数字
 */
export const validateNumAndLetter = (rule, value, callback) => {
  /*if (!/^[a-zA-Z0-9_]+$/.test(value)) {
    callback(new Error('只能输入字母和数字.'));
  }*/
  let reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
  if (reg.test(value)) {
    callback(new Error('不能输入输入中文.'));
  }
  callback();
};
/**
 * 验证姓名或名称
 */
export const validateName = (rule, value, callback) => {
  let regExp = /[`%*/\\|,.<>?"':]/;
  if (value !== '' && value !== undefined && !/^.{1,20}$/.test(value)) {
    callback(new Error('名字输入过长(限制20个字以内).'));
  } else if (value && regExp.test(value)) {
    callback(new Error(`不能包含下列任何特殊字符（\\ /:*?' "\`<>|）！%`));
  } else if (value && value.toLowerCase() === 'null') {
    callback(new Error(`名称请不要输入'null'`));
  }
  callback();
};
/**
 * 验证餐厅名称     正则/[`~!@#$%^&*()/\\|,.<>?"'();:_+=\[\]{}]/;
 */
export const validateRantName = (rule, value, callback) => {
  let regExp = /[`%*/\\|,.<>?"':]/;
  if (value !== '' && value !== undefined && !/^.{1,12}$/.test(value)) {
    callback(new Error('名字输入过长(限制12个字以内).'));
  } else if (value && regExp.test(value)) {
    callback(new Error(`不能包含下列任何特殊字符（\\ /:*?' "\`<>|, .）！%`));
  }
  callback();
};

/**
 * 验证地址
 */
export const validateAddress = (rule, value, callback) => {
  if (value !== '' && value !== undefined && !/^.{1,50}$/.test(value)) {
    callback(new Error('地址输入过长(限制50个字以内).'));
  }
  callback();
};

/**
 * 验证信用码
 */
export const validateCreditCode = (rule, value, callback) => {
  let regExp = /[^a-zA-Z0-9]/;
  if (value !== undefined && value.length !== 18) {
    callback(new Error('社会信用代码输入长度(限制18个字符).'));
  } else if (value && regExp.test(value)) {
    callback(new Error('不能输入数字、字母以外的字符！'));
  }
  callback();
};


/**
 * 验证纳税识别号
 */
export const validateidecode = (rule, value, callback) => {
  let regExp = /[^a-zA-Z0-9]/;
  if (value == '') {
    callback(new Error('请输入纳税识别号'));
  } else if (value && regExp.test(value)) {
    callback(new Error('不能输入数字、字母以外的字符！'));
  }
  callback();
};

/**
 * 验证发票抬头
 */
export const validateinvtopic = (rule, value, callback) => {
  let regExp = /[^A-Za-z0-9\u4e00-\u9fa5]+/;
  if (value == '') {
    callback(new Error('请输入发票抬头'));
  } else if (value && regExp.test(value)) {
    callback(new Error('不能输入汉字、数字、字母以外的字符！'));
  }
  callback();
};


/**
 * 验证备注
 */
export const validateMark = (rule, value, callback) => {
  if (value !== '' && value !== undefined && !/^.{1,150}$/.test(value)) {
    callback(new Error('备注输入过长(限制150个字以内).'));
  }
  callback();
};

/**
 * 验证密码
 */
export const  validatePwd = (rule, value, callback) => {
  if (!/^[0-9]*$/.test(value)) {
    callback(new Error("密码只能为数字"));
  } else if (value.length !== 6) {
    callback(new Error('密码必须为六位数'));
  } else {
    callback();
  }
};


/**
 * 验证只能是整数，且不能为0
 */
export const validateInt = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入内容'));
  }
  if (value && !(/(^[1-9]\d*$)/.test(value))) {
    callback(new Error('请输入正整数'));
  }
  callback();
};

/**
 * 验证不能为0
 */
export const validateNot0 = (rule, value, callback) => {
  if (value === 0) {
    callback(new Error('不能等于0'));
  }
  callback();
};


/**
 * 轮播时间 - 验证只能是整数，且在3-60s
 */
export const validateSTime = (rule, value, callback) => {
  if (value && !(/(^[1-9]\d*$)/.test(value))) {
    callback(new Error('请输入正整数'));
  } else if (value < 3 || value > 60) {
    callback(new Error('轮播时间需在3-60s以内.'));
  }
  callback();
};

/**
 * 验证数字不能超过100，并且为整数
 */
export const validateDiscount = (rule, value, callback) => {
  if (value && value !== '' && (!(/^[1-9]\d*$/.test(value)))) {
    callback(new Error('请输入不为0，且不以0开头的整数'));
  } else if (value && parseInt(value) > 100) {
    callback(new Error('折扣最大只能输入100，且不以0开头'));
  } else {
    callback();
  }
};

/**
 * 验证餐标
 */
export const validateStandard = (rule, value, callback) => {
  if (value && value !== '' && (!(/^[1-9]\d*$/.test(value)))) {
    callback(new Error('请输入不为0，且不以0开头的整数'));
  } else if (value && parseInt(value) > 1000) {
    callback(new Error('餐标最大只能输入1000'));
  } else {
    callback();
  }
};

/**
 * 验证密码
 */
export const validPwd = (rule, value, callback) => {
  if (!/^[0-9]*$/.test(value)) {
    callback(new Error("密码不合法，请重新输入"));
    return;
  }
  callback();
};

export const validPwd_login = (value) => {
  if (!/^[0-9]*$/.test(value)) {
    return false;
  }
  return true;
};

export const eWord = (rule, value, callback) => {     // /^[a-zA-Z]*$/
  let reg = /^[0-9a-zA-Z]*$/
  if (!reg.test(value)) {
    callback(new Error("权限编码只能为字母或者数字"));
    return;
  }
  callback();
};

export const eWordNum = (rule, value, callback) => {     // /^[a-zA-Z]*$/
  let reg = /^[0-9a-zA-Z]*$/
  if (!reg.test(value)) {
    callback(new Error("只能为字母或者数字"));
    return;
  }
  callback();
};
/**
 * 验证手机号
 */
export const validPhone = (rule, value, callback) => {
  /*if (!(/^1[34578]\d{9}$/.test(value))) {*/
  if (value === '') {
    callback(new Error('请输入手机号'));
  }
  if (!(/^1\d{10}$/.test(value))) {
    callback(new Error('手机号格式不对'));
  }
  callback();
};

export const validNum = (rule, value, callback) => {
  if (value && !/^[0-9]*$/.test(value)) {
    callback(new Error("输入内容只能为数字"));
    return;
  }
  callback();
};

// 企业简称
export const validAccountname = (rule, value, callback) => {
  let reg = new RegExp("^[\u4e00-\u9fa5a-zA-Z]+$");
  if (!reg.test(value)) {
    callback(new Error('只能输入字母和中文.'));
  }
  callback();
};

export const validPhone_login = (value) => {
  if (!(/^1\d{10}$/.test(value))) {
    return false;
  }
  return true;
};
/**
 * 验证是否为拼音
 */
export const validatePY = (rule, value, callback) => {
  let pyp = new RegExp("[A-Za-z]+");
  if (value === '') {
    callback(new Error('请输入原材料首字母拼音'));
  } else {
    if (pyp.test(value)) {
      callback(new Error('请输入拼音'));
    }
    callback();
  }
};

/**
 * 账号管理 - 验证密码
 */
export const validatePswd = (rule, value, callback) => {
  if (!value) {
    callback();
    return;
  } else {
    if (!/^[0-9]*$/.test(value)) {
      callback(new Error("密码只能为数字"));
      return;
    }
    if (value.length !== 6) {
      callback(new Error("请输入6位数字"));
      return;
    }
    callback();
  }
};
/**
 * 验证URL
 */
export const validateURL = (rule, value, callback) => {
  let reUrl = /:\/\/([\w-]+(\.[\w-]+)*\/?)+(\?([\w\-\.,@?^=%&:\/~\+#]*)+)?$/;
  let regExp = /[`*\,<>']/;
  if (value !== '' && value !== undefined && !/^.{1,1000}$/.test(value)) {
    callback(new Error('url输入过长(限制20个字以内).'));
  } else if (value && regExp.test(value)) {
    callback(new Error(`不能包含下列任何特殊字符（\\ /*' "\`<>|）！`));
  } else if (value && !reUrl.test(value)) {
    callback(new Error(`url格式不对'`));
  }
  callback();
};



// WEBPACK FOOTER //
// ./src/config/mValidate.js